import { c as _c } from "react/compiler-runtime";
export default function ArtBlocksIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <img src="/Art-Blocks-icon.jpg" alt="Art Blocks" className="tw-rounded-full tw-object-contain tw-flex-shrink-0 tw-h-5 tw-w-5 tw-align-top" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}